import React, { useState, useEffect, useContext } from "react";
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import Select from "react-select";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Modal } from "../../../imports";
import { AgregarProcesos } from "../../../servicios/ServicioProcesos";
import { useForm } from "react-hook-form";
import AlertContext from "../../GlobalComponents/Alert/contexts/alertContext";

const AddTechModal = ({
    showAddModal,
    setShowAddModal,
    errors,
    optionslistVacantes,
    optionslistUsuarios,
    optionslistEstado,
    idCurriculum,
    filtrar,
}) => {
    const jsonUsuario = sessionStorage.getItem("USER_DATA");
    const usuario = JSON.parse(jsonUsuario);
    const alertCtx = useContext(AlertContext);

    const [selectedVacante, setSelectedVacante] = useState({
        value: "",
        label: "--Seleccione una vacante--",
    });
    const [selectedUsuario, setSelectedUsuario] = useState({
        value: "",
        label: "--Seleccione un usuario--",
    });
    const [selectedEstado, setSelectedEstado] = useState({
        value: "",
        label: "--Seleccione un estado--",
    });

    const { register, getValues, setValue, handleSubmit, formState } = useForm({
        mode: "all",
        defaultValues: {
            descripcion: "",
        },
    });

    const { errors: formErrors } = formState;

    const validationMessages = {
        descripcion: [
            {
                type: "required",
                message: "Por favor ingrese una descripción.",
            },
            {
                type: "maxLength",
                message: "La descripción no puede exceder 25 caracteres.",
            },
        ],
    };

    const limpiarFormulario = () => {
        setValue("descripcion", "");
        setSelectedVacante({ value: "", label: "--Seleccione una vacante--" });
        setSelectedUsuario({ value: "", label: "--Seleccione un usuario--" });
        setSelectedEstado({ value: "", label: "--Seleccione un estado--" });
    };

    const guardarProceso = async () => {
        const descripcion = getValues("descripcion");
        const vacante = selectedVacante.value;
        const usuarioSeleccionado = selectedUsuario.value;
        const estado = selectedEstado.value;

        if (!descripcion || !vacante || !usuarioSeleccionado || !estado) {
            alertCtx.error("Todos los campos son obligatorios.");
            return;
        }

        const data = {
            Descripcion: descripcion,
            IdVacante: vacante,
            IdPersona: usuarioSeleccionado,
            UsuarioCreacion: usuario?.Correo || "default@example.com",
            IdEstado: estado,
        };

        const response = await AgregarProcesos(data);

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
            filtrar();
            
            limpiarFormulario();
            setShowAddModal(false);
        } else {
            alertCtx.error(response.mensaje);
        }
    };

    useEffect(() => {
        limpiarFormulario();
    }, [showAddModal]);

    useEffect(() => {
        if (idCurriculum) {
            const usuarioSeleccionado = optionslistUsuarios.find(option => option.value === idCurriculum);
            setSelectedUsuario(usuarioSeleccionado || { value: "", label: "--Seleccione un usuario--" });
        }
    }, [idCurriculum, optionslistUsuarios]);

    return (
        <Modal
            isVisible={showAddModal}
            onClose={() => setShowAddModal(false)}
            handleSubmit={handleSubmit}
            onSaveOptions={guardarProceso}
            showCloseIcon={false}
            insideContainer={{
                className: 'w-full', // Usa w-full para ocupar todo el ancho permitido
                style: { maxWidth: '500px', padding: '24px' },
            }}
        >
            <div className="flex justify-end m-2 w-100">
                <button
                    className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600"
                    onClick={() => setShowAddModal(false)}
                    aria-label="close modal"
                    role="button"
                >
                    <XMarkIcon className="text-red-RS h-6 w-6" />
                </button>
            </div>
            <form className="space-y-4">
                <div className="w-96 mx-auto">
                    <div className="flex flex-col items-center">
                        <PlusCircleIcon className="w-8 h-8 text-green-500" />
                        <h1 className="text-base font-bold text-white">Agregar Proceso</h1>
                    </div>
                    <div className="w-full m-3">
                        <label className="block mb-2 text-sm font-medium text-white">
                            Descripción
                        </label>
                        <input
                            type="text"
                            {...register("descripcion", { required: true, maxLength: 25 })}
                            id="descripcion"
                            name="descripcion"
                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                            placeholder="Descripción"
                        />
                        {validationMessages.descripcion.map((msg) =>
                            formErrors.descripcion?.type === msg.type ? (
                                <p key={msg.type} className="text-sm text-red-RS mt-2">
                                    {msg.message}
                                </p>
                            ) : null
                        )}
                    </div>
                    {/* Vacante */}
                    <div className="w-full m-3">
                        <label className="block mb-2 text-sm font-medium text-white">
                            Vacante
                        </label>
                        <Select
                            isSearchable
                            id="catvacante"
                            name="catvacante"
                            onChange={setSelectedVacante}
                            value={selectedVacante}
                            options={optionslistVacantes}
                            placeholder="--Seleccione una vacante--"
                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                        />
                    </div>
                    {/* Usuario */}
                    <div className="w-full m-3">
                        <label className="block mb-2 text-sm font-medium text-white">
                            Usuario
                        </label>
                        <Select
                            isSearchable
                            id="catusuario"
                            name="catusuario"
                            onChange={setSelectedUsuario}
                            value={selectedUsuario}
                            options={optionslistUsuarios}
                            placeholder="--Seleccione un usuario--"
                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                            isDisabled={idCurriculum !== undefined} 
                        />
                    </div>
                    {/* Estado */}
                    <div className="w-full m-3">
                        <label className="block mb-2 text-sm font-medium text-white">
                            Estado
                        </label>
                        <Select
                            isSearchable
                            id="catestado"
                            name="catestado"
                            onChange={setSelectedEstado}
                            value={selectedEstado}
                            options={optionslistEstado}
                            placeholder="--Seleccione un estado--"
                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                        />
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default AddTechModal;
